import { usePOSSummary } from "@faire/deprecated-retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useIsUnsubscribedToMarketingEmails } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useIsUnsubscribedToMarketingEmails";
import { useRetailerStatus } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailerStatus";
import { useRetailerType } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailerType";
import { useShowContextualAppDownloadCTAs } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useShowContextualAppDownloadCTAs";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { nextValue } from "@faire/deprecated-retailer-visitor-shared/lib/nextValue";
import { getSettingEnableOptInNudge } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingEnableOptInNudge";
import { useMilestone } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { POS_MARKETING_BANNERS_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/POS_MARKETING_BANNERS_DISMISSED";
import { IRetailerLinkCohortEnum } from "@faire/web-api--source/indigofair/retailers/pos/IRetailerLinkCohortEnum";

import { FooterCTAContent } from "./useCtaVariants";

const FOOTER_BANNERS_SEEN_KEY = "FOOTER_BANNERS_SEEN";

export const useGetVariant = (
  hideReferral?: boolean,
  showRetailerFooter?: boolean
): FooterCTAContent => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { showContextualAppDownloadCTAs } = useShowContextualAppDownloadCTAs();

  const loggedInOrOutVariant = isLoggedInRetailer
    ? FooterCTAContent.APP_DOWNLOAD
    : FooterCTAContent.LOGGED_OUT;
  const { retailerLinkCohort } = usePOSSummary();
  const { hasOccurred: hasDismissedPosBanner } = useMilestone(
    POS_MARKETING_BANNERS_DISMISSED
  );
  const { isNewUser } = useRetailerType();
  const { showR2B } = useRetailerStatus();

  const { isUnsubscribedToMarketingEmails } =
    useIsUnsubscribedToMarketingEmails();

  const shouldShowOptInNudgeBanner =
    isUnsubscribedToMarketingEmails && getSettingEnableOptInNudge();
  const shouldShowPOSCohortBanner =
    SUPPORTED_POS_BANNER_COHORTS.includes(retailerLinkCohort) &&
    (!hasDismissedPosBanner ||
      retailerLinkCohort ===
        IRetailerLinkCohortEnum.RetailerLinkCohort.INACTIVE);

  if (showRetailerFooter) {
    if (isNewUser) {
      return loggedInOrOutVariant;
    }

    const retailerFooterVariants = [];
    // Should show R2B
    if (!hideReferral && showR2B) {
      retailerFooterVariants.push(FooterCTAContent.R2B_REFERRAL);
    }

    // Should show app download banner
    if (showContextualAppDownloadCTAs) {
      retailerFooterVariants.push(FooterCTAContent.APP_DOWNLOAD);
    }

    // Should show opt in nudge banner
    if (shouldShowOptInNudgeBanner) {
      retailerFooterVariants.push(FooterCTAContent.OPT_IN_NUDGE);
    }

    if (shouldShowPOSCohortBanner) {
      retailerFooterVariants.push(FooterCTAContent.POS_COHORT);
    }

    return (
      nextValue(retailerFooterVariants, FOOTER_BANNERS_SEEN_KEY) ??
      loggedInOrOutVariant
    );
  }
  return loggedInOrOutVariant;
};

const SUPPORTED_POS_BANNER_COHORTS = [
  IRetailerLinkCohortEnum.RetailerLinkCohort.NEW,
  IRetailerLinkCohortEnum.RetailerLinkCohort.CHURNED,
  IRetailerLinkCohortEnum.RetailerLinkCohort.INACTIVE,
];
